import {SubscriptionPriceBoxNoticeData, useSubscriptionPriceBoxNotice} from '@udemy-v2/notices';
import React, {createContext, ReactNode, useContext, useMemo} from 'react';
import {useConsumerSubscriptionPlan} from '@udemy-v2/subscription-graphql';
import {useInterpolatedSubscriptionNotice} from '@/features/course-landing-page/components/subscription-notice/subscription-notice';

export interface CLPNoticeContext {
    subscriptionPriceBoxNoticeData?: SubscriptionPriceBoxNoticeData;
}

export const ReactCLPNoticeContext = createContext<CLPNoticeContext | undefined>(undefined);

interface ReactClpNoticeContextProviderProps {
    children: ReactNode;
}

export const ClpNoticeContextProvider: React.FC<ReactClpNoticeContextProviderProps> = ({
    children,
}) => {
    const {notices} = useSubscriptionPriceBoxNotice();
    const subscriptionPlan = useConsumerSubscriptionPlan();

    // Extract raw notice if available
    const rawNotice = notices.length ? notices[0].data : undefined;

    // Use our fixed hook that safely handles undefined values
    const interpolatedNotice = useInterpolatedSubscriptionNotice(
        subscriptionPlan && 'id' in subscriptionPlan ? subscriptionPlan : undefined,
        rawNotice,
    );

    // Set the context value based on available data
    const contextValue = useMemo(() => {
        if (interpolatedNotice) {
            return {subscriptionPriceBoxNoticeData: interpolatedNotice};
        }
        return undefined;
    }, [interpolatedNotice]);

    return (
        <ReactCLPNoticeContext.Provider value={contextValue}>
            {children}
        </ReactCLPNoticeContext.Provider>
    );
};

export function useClpNoticeContext(): CLPNoticeContext | undefined {
    return useContext(ReactCLPNoticeContext);
}
